import { Component, EventEmitter, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'modal-pin-change-component',
  templateUrl: './modal-pin-change.component.html',
  styleUrls: ['./modal-pin-change.component.scss']
})
export class ModalPinChangeComponent {
  @Output() openSupportModal = new EventEmitter<boolean>();
  public isLoading = false;

  constructor(public modalCtrl: ModalController) {}

  confirm() {
    this.isLoading = true;
    return this.modalCtrl.dismiss(true, 'confirm');
  }

  cancel() {
    return this.modalCtrl.dismiss(false, 'cancel');
  }
} 